import styled from '@emotion/styled';
import { useRef } from 'react';
import { useFocusRing, useTag, useButton } from 'react-aria';

import { Glyph } from '../Glyph';
import { TextSmall } from '../text/TextSmall';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

export function Tag(props) {
  const ref = useRef(null);
  const tag = useTag(props, props.state, ref);
  const focusRing = useFocusRing({ within: true });

  return (
    <S.Tag
      ref={ref}
      {...tag.rowProps}
      {...focusRing.focusProps}
      color={theme.color.white}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <S.Text {...tag.gridCellProps}>{props.item.rendered}</S.Text>

      {tag.allowsRemoving && <RemoveButton {...tag.removeButtonProps} />}
    </S.Tag>
  );
}

function S() {}
Tag.S = S;

S.Tag = styled(TextSmall)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: max-content;
  height: 24px;
  border-radius: 12px;
  background-color: ${theme.color.blue};
  overflow: hidden;
  padding: 0 4px 0 8px;
  outline: none;
`;

S.Text = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 4px;
`;

function RemoveButton(props) {
  const ref = useRef(null);
  const button = useButton(props, ref);

  return (
    <button {...button.buttonProps} ref={ref}>
      <Glyph source={glyph.core.crossCircle} color={theme.color.white} size="20px" />
    </button>
  );
}
